export default __webpack_public_path__ + "static/media/Affiliate_Login.1f289b2f.svg";